//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FunnelPacks from './funnel/FunnelPacks';
import FunnelCustomer from './funnel/FunnelCustomer';
import FunnelSummary from './funnel/FunnelSummary';
import FunnelPayment from './funnel/FunnelPayment';
import FunnelPricing from './funnel/FunnelPricing';
import { debounce } from "./flex/utils/helpers";

export default {
    components: {
        FunnelPacks,
        FunnelCustomer,
        FunnelSummary,
        FunnelPayment,
        FunnelPricing,
    },
    props: {
        lang: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            steps: {
                'packs':'funnel-packs',
                'customer':'funnel-customer',
                'summary':'funnel-summary',
                'payment':'funnel-payment',
            },
            currentStep: 0,
            currentStepName: 'packs',
            stepPassed: 0,
            numberSteps: 4,

            pricing: {},
        }
    },
    computed: {
        computedComponent() {
            return this.steps[ Object.keys( this.steps )[ this.currentStep ] ];
        },
    },
    watch: {
        currentStep() {
            this.currentStepName = Object.keys( this.steps )[ this.currentStep ];
        }
    },
    methods: {
        refreshPricing()
        {
            this.$app.get('axios').get('/api/funnel/pricing').then( response => {
                this.pricing = {...response.data};
            } );
        },

        previousStep(step)
        {
            if ( step === -1 ) {
                this.currentStep--;
            } else {
                this.currentStep = step;
            }

            this.$nextTick( () => history.pushState(undefined, undefined, "#/" + this.currentStepName ) );

            this.$el.scrollIntoView({ behavior: 'smooth' } )
        },

        nextStep()
        {
            this.refreshPricing();

            this.currentStep++;
            this.$nextTick( () => history.pushState(undefined, undefined, "#/" + this.currentStepName ) );

            this.$el.scrollIntoView({ behavior: 'smooth' })
        },

        changeStep(index)
        {
            if ( this.stepPassed < index ) {
                this.stepPassed = index;
            }

            this.currentStep = index;
            this.$nextTick( () => history.pushState(undefined, undefined, "#/" + this.currentStepName ) );

            this.$el.scrollIntoView({ behavior: 'smooth' })
        },

        handleHash() {
            let hash = window.location.hash;

            if ( hash !== '' ) {
                hash = hash.substring( 2 );

                const items = Object.keys( this.steps );

                const step = items.indexOf( hash );

                if ( step !== -1 ) {
                    this.currentStep = step;

                }
            }
        }
    },
    created() {
        this.handleHash();

        window.addEventListener('popstate', () => this.handleHash() );
    },
    mounted() {
        this.refreshPricing();

        const pricingEl = this.$refs.pricing.$el;
        const containerEl = this.$el;

        const margin_top = 60;

        const handleScroll = function (scroll_y) {
            const container_rect = containerEl.getBoundingClientRect();
            const pricing_rect = pricingEl.getBoundingClientRect();

            if ( window.innerWidth >= 720 ) {
                const container_bottom = container_rect.height - 40;
                const pricing_bottom = pricing_rect.height;

                let pricing_top = ( scroll_y - 168 + margin_top );

                if ( pricing_top >= 0 && ( pricing_top + pricing_bottom ) <= container_bottom ) {
                    pricingEl.style.top = pricing_top + "px";
                }

                if ( pricing_top <= 0 ) {
                    pricingEl.style.top = 0 + "px";
                }

                if ( ( pricing_top + pricing_bottom ) >= container_bottom ) {
                    pricingEl.style.top = container_bottom - pricing_bottom + "px";
                }
            }
        }

        handleScroll( 0 );

        window.addEventListener( 'scroll', debounce( () => {
            handleScroll( window.scrollY );
        }, 15 ) );
    }
}
